import { type Card, RANK_CHARS, rankOf, suitOf } from '@tctp/engine/browser';

const GLYPHS = ['♣', '♦', '♥', '♠'] as const;
const NAMES = ['clubs', 'diamonds', 'hearts', 'spades'] as const;

export interface CardView { rank: string; glyph: string; suit: string; red: boolean; label: string }

export function cardView(card: Card): CardView {
  const r = RANK_CHARS[rankOf(card)]!;
  const s = suitOf(card);
  const rank = r === 'T' ? '10' : r;
  return { rank, glyph: GLYPHS[s]!, suit: NAMES[s]!, red: s === 1 || s === 2, label: `${rank} of ${NAMES[s]}` };
}
